import {Component, effect, inject, signal} from '@angular/core';
import {Location, NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {
  GatewayButtonComponent
} from "src/app/presentation/main-view/information-center/gateways/gateway-button/gateway-button.component";
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {LoRaGateway} from "src/app/infrastructure/moovement-api/models/asset";
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {GatewayStatusStore} from 'src/app/domain/devices/gateway/gateway-status.store';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';

@Component({
  selector: 'app-gateways',
  imports: [
    GatewayButtonComponent,
    GatewaySvgComponent,
    NgClass,
  ],
  templateUrl: './gateways.component.html',
  styleUrl: './gateways.component.css'
})
export class GatewaysComponent {

  onlineGateways: Array<LoRaGateway> = []
  unknownGateways: Array<LoRaGateway> = []
  offlineGateways: Array<LoRaGateway> = []
  loading = false;

  filter = signal<string | undefined>(undefined);
  filteredGateways = signal<LoRaGateway[]>([])

  private gatewayStore = inject(GatewayStore);
  private gatewayStatusStore = inject(GatewayStatusStore);
  private mainViewStore = inject(MainViewStore);
  private location = inject(Location);

  constructor(
    private dataSubscriptionService: DataSubscriptionService,
    protected viewportService: ViewportService
  ) {
    effect(() => {
      const value = this.filter();
      if (!value) {
        this.filteredGateways.set(this.gatewayStore.entities());
        return;
      }

      this.filteredGateways.set(this.gatewayStore.entities().filter(gateway => {
          return gateway?.id?.toLowerCase().includes(value)
            || gateway?.name?.toLowerCase().includes(value)
            || gateway?.ipAddress?.toLowerCase().includes(value)
        }
      ));
    });

    effect(() => {
      const gateways = this.filteredGateways();
      if (!gateways) return;

      const gatewayStatuses = this.gatewayStatusStore.entityMap();
      if (!gatewayStatuses) return;

      this.onlineGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return false;
        return status.normalisedValue === 'ONLINE';
      });

      this.offlineGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return false;
        return status.normalisedValue === 'OFFLINE';
      });

      this.unknownGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return true;
        return status.normalisedValue === undefined;
      });
    })
  }

  filterResults(input?: any) {
    const value = input?.value?.toLowerCase();
    this.filter.set(value);
  }

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }
}
